import { render, staticRenderFns } from "./mtbt.vue?vue&type=template&id=3bb6871c&scoped=true"
import script from "./mtbt.vue?vue&type=script&lang=js"
export * from "./mtbt.vue?vue&type=script&lang=js"
import style0 from "./mtbt.vue?vue&type=style&index=0&id=3bb6871c&prod&scoped=true&lang=css"
import style1 from "./mtbt.vue?vue&type=style&index=1&id=3bb6871c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6871c",
  null
  
)

export default component.exports